module.exports = __webpack_public_path__ + "static/media/cocktailSmall.bc1cfced.png";